/** Role-based sidebar navigation blueprint. */
const ALL = "*";

export const ROLE_NAV = {
  // Suntronix
  super_admin: ALL,
  management: ALL,
  operations: ALL,
  device_manager: ALL,
  sales_coordinator: [
    "/admin/customer-onboarding",
    "/", "/waiting-on-customer", "/customer-action-required", "/requests", "/approvals", "/assets", "/devices", "/lifecycle/people", "/control", "/deploy",
    "/catalogue", "/services", "/companies", "/employees",
    "/shipments", "/pickups", "/refresh-forecast", "/reports",
    "/orders/smart", "/commercial/crm/customers", "/finance/invoice-copies", "/finance/whatsapp-followup", "/commercial/acceptance-inbox",
  ],
  procurement: ["/", "/requests", "/catalogue", "/services", "/imports", "/companies", "/employees", "/reports", "/refresh-forecast", "/marketplace"],
  service: ["/", "/service", "/assets", "/devices", "/lifecycle/people", "/control", "/requests", "/pickups", "/inspection"],
  stores: ["/", "/warehouse", "/assets", "/devices", "/lifecycle/people", "/control", "/inspection", "/imports"],
  warehouse: ["/", "/warehouse", "/assets", "/devices", "/lifecycle/people", "/control", "/inspection", "/shipments", "/pickups"],
  packaging: ["/", "/shipments"],
  delivery: ["/", "/shipments"],
  finance: ["/", "/refresh-forecast", "/reports", "/audit", "/catalogue", "/invoices", "/finance/invoice-copies", "/finance/whatsapp-followup", "/orders/smart"],
  customer_experience: ["/", "/requests", "/approvals", "/exceptions", "/employees"],
  auditor: ["/", "/audit", "/reports", "/exceptions"],
  read_only: ["/", "/assets", "/devices", "/lifecycle/people", "/control", "/reports"],

  // Customer
  customer_global_admin: [
    "/", "/portal", "/approvals", "/exceptions", "/companies", "/employees",
    "/requests", "/assets", "/devices", "/lifecycle/people", "/control", "/deploy", "/offboarding",
    "/reservations", "/loaners", "/rma",
    "/pickups", "/inspection", "/data-erasure", "/itad",
    "/catalogue", "/services", "/refresh-forecast", "/warranty", "/refresh-engine", "/reports",
    "/users", "/audit", "/imports",
    "/connectors", "/discovery", "/discrepancies", "/duplicates",
    "/normalization", "/product-intelligence", "/data-quality", "/inventory-audit",
    "/source-priority", "/governance-centre", "/marketplace", "/sop",
  ],
  customer_it_admin: [
    "/", "/portal", "/approvals", "/exceptions", "/employees",
    "/requests", "/assets", "/devices", "/lifecycle/people", "/control", "/deploy", "/offboarding",
    "/reservations", "/loaners", "/rma",
    "/pickups", "/services", "/refresh-forecast", "/warranty", "/refresh-engine", "/imports",
    "/connectors", "/discovery", "/discrepancies", "/duplicates",
    "/data-quality", "/inventory-audit", "/governance-centre", "/marketplace", "/sop",
  ],
  customer_procurement: ["/", "/portal", "/requests", "/catalogue", "/services", "/refresh-forecast", "/reports", "/marketplace"],
  customer_finance: ["/", "/portal", "/refresh-forecast", "/reports", "/audit", "/catalogue", "/marketplace"],
  customer_hr: ["/", "/portal", "/employees", "/offboarding", "/requests", "/imports", "/marketplace"],
  customer_manager: ["/", "/portal", "/requests", "/approvals", "/employees", "/marketplace"],
  customer_employee: ["/my-devices", "/services", "/requests", "/marketplace"],
  customer_auditor: ["/", "/portal", "/audit", "/reports", "/exceptions"],
  customer_viewer: ["/", "/portal", "/assets", "/devices", "/reports"],
};

export function allowedRoutes(role) {
  const v = ROLE_NAV[role];
  return v || ["/"];
}

export function canSee(role, path) {
  const v = ROLE_NAV[role];
  if (!v) return path === "/";
  if (v === ALL) return true;
  return v.includes(path);
}

// User / role administration is default-deny: only these roles may see and
// reach the Users & Roles admin surface (mirrors backend USER_ADMIN_ROLES).
export const USER_ADMIN_ROLES = new Set([
  "super_admin", "management", "customer_global_admin", "customer_it_admin",
]);

export function canAdminUsers(role) {
  return USER_ADMIN_ROLES.has(role);
}

export function defaultLanding(role) {
  if (role === "customer_employee") return "/my-devices";
  return "/";
}
